module.exports = __webpack_public_path__ + "img/Reports.c3bd1509.svg";